import { scaleLinear, scaleTime } from 'd3-scale';
import PredictionLineSeries from './Charts/MultiPredictionTimeSeriesChart/components/PredictionLineSeries';
import { formatSeriesData } from './Charts/MultiPredictionTimeSeriesChart/utils';
import { memo } from 'react';
import { useTheme } from 'styled-components';

const STROKE_WIDTH = 2;
const HALF_STROKE_WIDTH = STROKE_WIDTH / 2;

const Sparkline = memo(
    ({
        data,
        width,
        height,
        margin = {
            t: HALF_STROKE_WIDTH,
            b: HALF_STROKE_WIDTH,
            l: HALF_STROKE_WIDTH,
            r: HALF_STROKE_WIDTH,
        },
        strokeWidth = STROKE_WIDTH,
        skipPrediction = false,
    }) => {
        const theme = useTheme();
        const {
            accessors,
            xMin,
            xMax,
            yMin,
            yMax,
            formattedData: [{ historical, prediction }],
        } = formatSeriesData([{ timeSeries: data }], { skipPrediction });
        const xScale = scaleTime()
            .domain([xMin, xMax])
            .range([margin.l, width - (margin.l + margin.r)]);
        const yScale = scaleLinear()
            .domain([yMin, yMax])
            .range([height - (margin.b + margin.t), margin.t]);
        const x = (d) => xScale(new Date(accessors.xAccessor(d)));
        const y = (d) => yScale(accessors.yAccessor(d));

        return (
            <svg width={width} height={height}>
                <PredictionLineSeries
                    x={x}
                    y={y}
                    historical={historical}
                    prediction={prediction}
                    strokeColor={theme.google_blue}
                    strokeColorPrediction={theme.purple_1}
                    predictionStrokeDasharray={true}
                    strokeWidth={strokeWidth}
                />
            </svg>
        );
    },
);

export default Sparkline;
